import type { ResourceProps } from "@refinedev/core";
import { getComplianceResources, type RefineResource } from "@kit/refine-resources";

export const kitResources: RefineResource[] = getComplianceResources({ dataProviderName: "default" });
export const resourceBySlug = Object.fromEntries(kitResources.map((resource) => [resource.name, resource]));
export const refineResources: ResourceProps[] = kitResources.map((resource) => ({
  name: resource.name,
  list: resource.list,
  show: resource.show,
  create: resource.create,
  edit: resource.edit,
  meta: { ...resource.meta, canDelete: true },
}));
